import {assetsCDN} from "../../utils/globals";
import {
    getSizeForProcSimpleFit,
    disableCanvasSmoothing,
    enableCanvasSmoothing,
    getUrlParameter,
    validateObject,
    createCanvas,
    numericSize,
    textualSize,
    drawImage,
    cacheGet,
    cacheSet,
    error,
    log, getImage
} from "../../utils/utils"


/**
 * @class SurfaceRenderer
 */
export default class SurfaceRenderer {

    surface = {};
    photos = [];
    photoAssignment = [];
    env = 'prod';
    size = 'small';
    width = 0;
    height = 0;
    printableAreaX = 0;
    printableAreaY = 0;
    scale = 1;
    hasTextData = false;
    isLandscape = false;
    addImageDropIcon = true;
    debug = false;
    canvas = null;
    surfaceImageObject = null;
    backgroundImageObject = null;
    downloadedAssets = {};
    isMagicShop = false;
    sizesDictionary = {
        "x-small": 1,
        "small": 2,
        "medium": 3,
        "large": 4,
        "x-large": 5
    }
    static imageDropIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAhCAQAAAAbxMGgAAAAu0lEQVR4Ae3VsQqDQAwG4Hu0PoqP0tGxo4LggS/hZn0J15vEDkIHB8e0+hME6SUc3tDh8g9RwY+QJYYyukdIZqijGNVtkLs8zzNBCUrQH0GusG9XXILAVGtJ1QpKhWRmCygVkhmVYkhmREqHlhzMmXo9AqFmOiNIMwVCPEHf4qlvecJgCDsZLH4fLHYWDPFqDwjrl6CfVdO895EAjfvbTLXnrnkv7ZKjHxPxd9+lVVLeAH27kYImJRqUoA+4uIr587BrmgAAAABJRU5ErkJggg==";
    static dropIconMaxWidth = 36;
    static dropIconMaxHeight = 33;
    static defaultDropIconBgColor = "#B9B9BA";

    /**
     * Constructing a new instance of SurfaceRenderer
     * @memberOf SurfaceRenderer
     * @param {SurfaceRendererInput} params
     * @example
     * const renderer = new SurfaceRenderer( {"env":"prod","surface":{"id":144019,"name":"612_L_20x30-puzzle_99_sfly_685_pictogram-DC_black_S1_a_17","surfaceUrl":"//gim1.shutterfly.com/asset/fetch?comproot=true&current=true&reptype=asset.trans.text.png.280&assettype=layeredlayout&assetname=612_L_20x30-puzzle_99_sfly_685_pictogram-DC_black_S1_a_17","canvasWidth":2160,"canvasHeight":1440,"imageAreas":[{"id":"1.2.34","seqno":95,"x":1709.9380645751953,"y":1066.7250137329102,"width":450.0629997253418,"height":373.27498626708984,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.30","seqno":105,"x":908.197998046875,"y":1064.3869857788086,"width":346.06298446655273,"height":375.6130142211914,"orientation":"PORTRAIT","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.32","seqno":115,"x":0,"y":1066.7250137329102,"width":452.9999885559082,"height":373.27498626708984,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.28","seqno":125,"x":1248.4769897460938,"y":948.6769866943359,"width":457.10400009155273,"height":491.32301330566406,"orientation":"PORTRAIT","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.26","seqno":135,"x":453.6720085144043,"y":948.6769866943359,"width":457.10400009155273,"height":491.32301330566406,"orientation":"PORTRAIT","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.22","seqno":145,"x":1707.0059509277344,"y":715.203987121582,"width":452.99401473999023,"height":350.86400985717773,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.24","seqno":155,"x":908.197998046875,"y":718.2209701538086,"width":343.20801544189453,"height":347.8479881286621,"orientation":"SQUARE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.20","seqno":165,"x":0,"y":715.203987121582,"width":452.9999885559082,"height":350.86400985717773,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.18","seqno":175,"x":1251.4059448242188,"y":483.1330146789551,"width":455.6000061035156,"height":468.54399490356445,"orientation":"SQUARE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.16","seqno":185,"x":453.6720085144043,"y":483.1330146789551,"width":454.5259895324707,"height":468.54399490356445,"orientation":"SQUARE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.14","seqno":195,"x":1707.0059509277344,"y":369.70000076293945,"width":452.99401473999023,"height":349.7999839782715,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.12","seqno":205,"x":0,"y":369.70000076293945,"width":450.0300064086914,"height":349.7999839782715,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.10","seqno":215,"x":1712.8679809570312,"y":0,"width":447.13198471069336,"height":373.27498626708984,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.8","seqno":225,"x":1248.4769897460938,"y":0,"width":458.528995513916,"height":482.1650161743164,"orientation":"SQUARE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.6","seqno":235,"x":908.197998046875,"y":0,"width":346.06298446655273,"height":369.70000076293945,"orientation":"PORTRAIT","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.4","seqno":245,"x":453.6720085144043,"y":0,"width":458.52600860595703,"height":482.1650161743164,"orientation":"SQUARE","areaType":"image.dynamic","colorGroup":{}},{"id":"1.2.2","seqno":255,"x":0,"y":0,"width":450.99999618530273,"height":368.00000381469727,"orientation":"LANDSCAPE","areaType":"image.dynamic","colorGroup":{}}],"textAreas":[{"id":"1.10.2","seqno":255,"x":929.6950149536133,"y":388.65800857543945,"width":302.6390075683594,"height":310.34200286865234,"subtype":"body","areaType":"text.body","defaultFont":{"color":"#FFFFFF","id":"body","name":"TradeGothic LT Bold","pointSize":260,"bold":false,"italic":false,"underline":false,"horizontalJustification":"center","verticalJustification":"middle"},"colorGroup":{},"t":true,"text":""}],"foilAreas":[]},"photos":[{"id":"14510281314","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510281314/medium/1556476453/enhance"},{"id":"14510273604","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510273604/medium/1556476249/enhance"},{"id":"14510278386","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278386/medium/1556476362/enhance"},{"id":"14510266039","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510266039/medium/1556476052/enhance"},{"id":"14510271189","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510271189/medium/1556476188/enhance"},{"id":"14510278446","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278446/medium/1556476363/enhance"},{"id":"14510278635","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278635/medium/1556476369/enhance"},{"id":"14510272777","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510272777/medium/1556476228/enhance"},{"id":"14510271503","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510271503/medium/1556476196/enhance"},{"id":"14510278507","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278507/medium/1556476365/enhance"},{"id":"14510285943","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510285943/medium/1556476595/enhance"},{"id":"14510285622","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510285622/medium/1556476585/enhance"}],"photoAssignment":[{"photoId":"14510285943","crop":[0,0.35,1,0.65],"imageAreaId":"1.2.22","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510285943/small/1556476595/enhance"},{"photoId":"14510285622","crop":[0,0.08,1,0.85],"imageAreaId":"1.2.14","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510285622/small/1556476585/enhance"},{"photoId":"14510281314","crop":[0,0.03,1,1],"imageAreaId":"1.2.2","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510281314/small/1556476453/enhance"},{"photoId":"14510281314","crop":[0.16,0,0.95,1],"imageAreaId":"1.2.26","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510281314/small/1556476453/enhance"},{"photoId":"14510278635","crop":[0,0.46,1,0.97],"imageAreaId":"1.2.18","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278635/small/1556476369/enhance"},{"photoId":"14510278507","crop":[0,0.46,1,0.97],"imageAreaId":"1.2.24","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278507/small/1556476365/enhance"},{"photoId":"14510278446","crop":[0,0.27,1,0.78],"imageAreaId":"1.2.16","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278446/small/1556476363/enhance"},{"photoId":"14510278386","crop":[0,0,1,0.95],"imageAreaId":"1.2.6","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278386/small/1556476362/enhance"},{"photoId":"14510278386","crop":[0,0.19,1,0.92],"imageAreaId":"1.2.32","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510278386/small/1556476362/enhance"},{"photoId":"14510273604","crop":[0,0.07,1,1],"imageAreaId":"1.2.4","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510273604/small/1556476249/enhance"},{"photoId":"14510273604","crop":[0,0.05,1,1],"imageAreaId":"1.2.28","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510273604/small/1556476249/enhance"},{"photoId":"14510272777","crop":[0,0.44,1,0.83],"imageAreaId":"1.2.12","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510272777/small/1556476228/enhance"},{"photoId":"14510271503","crop":[0,0.36,1,0.65],"imageAreaId":"1.2.20","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510271503/small/1556476196/enhance"},{"photoId":"14510271189","crop":[0,0.19,1,0.93],"imageAreaId":"1.2.10","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510271189/small/1556476188/enhance"},{"photoId":"14510271189","crop":[0,0.19,1,0.93],"imageAreaId":"1.2.34","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510271189/small/1556476188/enhance"},{"photoId":"14510266039","crop":[0.16,0,0.94,1],"imageAreaId":"1.2.30","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510266039/small/1556476052/enhance"},{"photoId":"14510266039","crop":[0.15,0,0.95,1],"imageAreaId":"1.2.8","url":"https://uniim1.shutterfly.com/ng/services/mediarender/THISLIFE/022057552872/media/14510266039/small/1556476052/enhance"}]} )
     */
    constructor(params) {
        Object.assign(this, params);

        this.validate();

        this.width = this.surface.canvasWidth;
        this.height = this.surface.canvasHeight;

        this.isLandscape = this.width > this.height;

        this.setCanvasSize();

        if (this.debug) log(`initiated SurfaceRenderer`, this);

        const dropIcon = new Image();
        dropIcon.onload = () => {
            cacheSet("dropIcon", dropIcon);
        };
        dropIcon.src = this.constructor.imageDropIcon;
    }

    /**
     * Outputs the generated product
     * @private
     * @memberOf SurfaceRenderer
     * @param {Boolean} returnAsImage - if to return as an image (default is false, return as canvas)
     * @return HTMLCanvasElement|String
     */
    output(returnAsImage = false) {
        this.canvas.dataset.origWidth = this.width;
        this.canvas.dataset.origHeight = this.height;
        return returnAsImage ? this.canvas.toDataURL() : this.canvas;
    }

    /**
     * Sorts the wells (Cells) by id - just like z-index (css)
     * @private
     * @memberOf SurfaceRenderer
     */
    sortWells() {
        this.surface.imageAreas = this.surface.imageAreas.sort((a, b) => a.id.localeCompare(b.id, undefined, {numeric: true}));
        this.surface.textAreas = this.surface.textAreas.sort((a, b) => a.id.localeCompare(b.id, undefined, {numeric: true}));
    }

    /**
     * Get photo for cell id, matching by imageAreaId
     * @private
     * @memberOf SurfaceRenderer
     * @param {String} cellId - cell id to match.
     * @return photo|Object
     */
    getPhotoForCell(cellId) {
        const photo = this.photoAssignment.find(photo => photo.imageAreaId === cellId);

        if (photo) {
            const photoExtra = this.photos.find(p => p.id === photo.photoId);
            if (!photoExtra) {
                error("Missing",
                    `missing photo extra data for cell ${cellId}`);
            }
            photo.url = photoExtra.url;
            return photo;
        } else if (this.addImageDropIcon) {
            return {dropIcon: true};
        }

        error("Missing", `missing photo for cell ${cellId}`);
    }

    /**
     * Generates text url for text-service
     * @private
     * @memberOf SurfaceRenderer
     * @param {TextArea} textArea - text area input
     * @return String
     */
    getTextUrl(textArea) {
        const p = textArea.defaultFont;
        const queryParams = {
            fontColor: p.color,
            text: textArea.text,
            fontSize: Math.round(p.pointSize),
            fontName: p.name,
            horizJustification: p.horizontalJustification,
            vertJustification: p.verticalJustification,
            underline: p.underline,
            italic: p.italic,
            brand: "SFLY",
            bold: p.bold,
            width: textArea.width.toFixed(0),
            height: textArea.height.toFixed(0),
            textAreaWidth: textArea.width / 72,
            textAreaHeight: textArea.height / 72
        };

        queryParams.width = (queryParams.width * this.scale).toFixed(0);
        queryParams.height = (queryParams.height * this.scale).toFixed(0);

        const queryURL = Object.keys(queryParams).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`).join('&');

        const domain = this.hasTextData || (this.env !== "prod" && this.env !== "stage") ? "https://proxy.photoccino.com" : assetsCDN(this.env);

        return `${domain}/proxy.php?endpoint=${encodeURIComponent(`${this.constructor.textsEndpoint}?${queryURL}`)}`;
    }

    /**
     * Validates the initial input (surface, photos, photoAssignment)
     * @private
     * @memberOf SurfaceRenderer
     */
    validate() {
        // Validate surface
        if (typeof this.surface !== "object") {
            error("Validation Error", "surface is not an object");
        } else {
            validateObject("surface", this.surface,
                ["id", "surfaceUrl", "canvasWidth", "canvasHeight", "imageAreas",
                    "textAreas"]);

            // ImageAreas validation
            if (Array.isArray(this.surface.imageAreas) && this.surface.imageAreas.length > 0) {
                this.surface.imageAreas.forEach((imageArea, index) => {
                    if (typeof imageArea !== "object") {
                        error("Validation Error",
                            `imageArea at index ${index} is not an object`);
                    } else {
                        validateObject(`surface.imageAreas - imageArea at index ${index}`,
                            imageArea,
                            ["id", "seqno", "x", "y", "width", "height"])
                    }
                })
            }

            // TextAreas validation
            if (Array.isArray(this.surface.textAreas) && this.surface.textAreas.length > 0) {
                this.surface.textAreas.forEach((textArea, index) => {
                    if (typeof textArea !== "object") {
                        error("Validation Error",
                            `textArea at index ${index} is not an object`);
                    } else {
                        validateObject(`surface.textAreas - textArea at index ${index}`,
                            textArea,
                            ["id", "seqno", "x", "y", "width", "height", "subtype",
                                "defaultFont", "text"])
                    }
                })
            }
        }

        // Photos validation
        if (Array.isArray(this.photos)) {
            this.photos.forEach((photo, index) => {
                if (typeof photo !== "object") {
                    error("Validation Error", `photo at index ${index} is not an object`);
                } else {
                    validateObject(`photos - photo at index ${index}`, photo,
                        ["id", "url"])
                }
            })
        }

        // PhotoAssignment validation
        if (Array.isArray(this.photoAssignment)) {
            this.photoAssignment.forEach((photo, index) => {
                if (typeof photo !== "object") {
                    error("Validation Error", `photo at index ${index} is not an object`);
                } else {
                    validateObject(`photoAssignment - photo at index ${index}`,
                        photo,
                        ["photoId", "crop", "imageAreaId"])
                }
            })
        }
    }

    /**
     * Draws the surface
     * @private
     * @memberOf SurfaceRenderer
     */
    drawSurface() {
        try {

            if (this.surfaceImageObject instanceof Image) {
                const img = this.surfaceImageObject;
                this.ctx.save();
                drawImage(this.ctx, [img, 0, 0, this.width, this.height]);
                this.ctx.restore();
            }

        } catch (err) {
            error("SurfaceRenderer", `Failed to draw surface! - ${err.message}`);
        }
    }

    /**
     * Draws the background
     * @private
     * @memberOf SurfaceRenderer
     */
    drawBackground() {
        try {

            if (this.backgroundImageObject instanceof Image) {
                const img = this.backgroundImageObject;
                this.ctx.save();
                drawImage(this.ctx, [img, 0, 0, this.width, this.height]);
                this.ctx.restore();
            }

        } catch (err) {
            error("SurfaceRenderer", `Failed to draw background! - ${err.message}`);
        }
    }

    /**
     * Renders a cropped image version into the canvas accroding to the crop data
     * @private
     * @memberOf SurfaceRenderer
     */
    renderCroppedImage(imageArea) {
        try {
            this.ctx.save();

            const transformation = this.constructor.getTransformation(imageArea.transformation);

            if (transformation.length === 7) {
                this.ctx.transform(
                    parseFloat(transformation[1]),
                    parseFloat(transformation[2]),
                    parseFloat(transformation[3]),
                    parseFloat(transformation[4]),
                    parseFloat(transformation[5]),
                    parseFloat(transformation[6])
                );
            }

            const isDropIcon = !(imageArea.imageObject instanceof Image);

            if (isDropIcon) {
                // Draw drop icon image
                let dropIcon = cacheGet("dropIcon");
                this.ctx.beginPath();
                this.ctx.rect(imageArea.x, imageArea.y, imageArea.width, imageArea.height);
                this.ctx.fillStyle = this.constructor.defaultDropIconBgColor;
                this.ctx.fill();
                this.ctx.stroke();

                if (this.addImageDropIcon) {
                    const ws = imageArea.width * 0.3;
                    const hs = imageArea.height * 0.3;

                    const rs = ws / hs;
                    const ri = dropIcon.width / dropIcon.height;

                    let [width, height] = rs > ri ? [dropIcon.width * hs / dropIcon.height, hs] : [ws, dropIcon.height * ws / dropIcon.width];

                    width = width > this.constructor.dropIconMaxWidth ? this.constructor.dropIconMaxWidth : width;
                    height = height > this.constructor.dropIconMaxHeight ? this.constructor.dropIconMaxHeight : height;

                    const x = imageArea.x + (imageArea.width / 2) - width / 2,
                        y = imageArea.y + (imageArea.height / 2) - height / 2;

                    enableCanvasSmoothing(this.ctx);
                    drawImage(this.ctx, [dropIcon, x, y, width, height]);
                    disableCanvasSmoothing(this.ctx);
                }

            } else {
                // Draw image
                const img = imageArea.imageObject;

                const start = {
                    x: (img.width * imageArea.crop[0]),
                    y: (img.height * (1 - imageArea.crop[3]))
                };
                const end = {
                    x: (img.width * imageArea.crop[2]),
                    y: (img.height * (1 - imageArea.crop[1]))
                };

                drawImage(this.ctx,
                    [img, start.x, start.y, end.x - start.x, end.y - start.y,
                        imageArea.x, imageArea.y, imageArea.width,
                        imageArea.height]);
            }

            this.ctx.restore();
        } catch (e) {
            console.log(e);
        }
    }

    setCanvasSize() {
        this.scale = 1;
        const size = numericSize(this.size);

        if (this.width > this.height) {
            this.scale = size / this.width;
            this.width = size;
            this.height = this.scale * this.height;
        } else {
            this.scale = size / this.height;
            this.height = size;
            this.width = this.scale * this.width;
        }


    }

    /**
     * Downloads photos, surface and texts
     * @private
     * @memberOf SurfaceRenderer
     */
    async downloadAssets() {

        const surface = {url: this.surface.surfaceUrl, isSurface: true, canFail: this.isMagicShop};
        const isBadSurface = surface.url ? surface.url.match(".*&reptype=asset\.trans\..*&assettype=layout&.*") : true;
        const assets = isBadSurface ? [] : [surface];

        const backgroundObject = {url: this.surface.backgroundUrl, canFail: this.isMagicShop};
        if (backgroundObject.url && backgroundObject.url.length > 0) {
            assets.push(backgroundObject);
        }

        if (this.surface.imageAreas && this.surface.imageAreas.length > 0) {
            let dropIcon = cacheGet("dropIcon");
            if (!dropIcon) {
                dropIcon = new Image();
                dropIcon.onload = () => {
                    cacheSet("dropIcon", dropIcon);
                };
                dropIcon.src = this.constructor.imageDropIcon;
            }

            this.surface.imageAreas.forEach(imageArea => {
                const photo = this.getPhotoForCell(imageArea.id);
                if (!photo.dropIcon) {
                    const photoSize = this.getPhotoSize(imageArea, photo)

                    if (photo.url.match(/procsimple/)) {
                        // Handle anonymous photos
                        const fit = getUrlParameter(photo.url, "rendersize");
                        imageArea.url = photo.url.replace(fit, getSizeForProcSimpleFit(photoSize));
                    } else {
                        imageArea.url = photo.url.replace(/medium|x-large|large/, photoSize);
                    }

                    imageArea.crop = photo.crop;
                    imageArea.canFail = true;
                    assets.push(imageArea);
                }
            });
        }

        this.surface.textAreas && this.surface.textAreas.forEach(textArea => {
            if (textArea.text && textArea.text.length > 0) {
                textArea.url = this.getTextUrl(textArea);
                textArea.canFail = true;
                textArea.timeout = 3000;
                assets.push(textArea);
            }
        });

        this.surface.embellishmentAreas && this.surface.embellishmentAreas.forEach(embellishmentArea => {
            embellishmentArea.canFail = true;
            assets.push(embellishmentArea);
        })

        this.downloadedAssets = await Promise.all(assets.map(asset => this.downloadAsset(asset)));

        if (!isBadSurface) {
            this.surfaceImageObject = surface.imageObject;
        }
        if (backgroundObject.url && backgroundObject.url.length > 0) {
            this.backgroundImageObject = backgroundObject.imageObject;
        }
    }

    /** Return size of image, if we have the image already have in cache bigger size, return the size from cache */
    getPhotoSize(imageArea, photo) {
        const photoSize = textualSize(Math.max(imageArea.width, imageArea.height) * this.scale);
        const photo_key = `photo_${photo.photoId}`
        const cached_size = cacheGet(photo_key)
        if (!cached_size || this.sizesDictionary[photoSize] > this.sizesDictionary[cached_size]) {
            cacheSet(photo_key, photoSize)
            return photoSize
        }
        return cached_size
    }

    async downloadAsset(asset) {
        asset.imageObject = null;
        try {
            asset.imageObject = await getImage(asset.url, false, asset.timeout);
            return asset;
        } catch (e) {
            if (!!asset.isSurface && window._MagicRendererInstance) {
                this.constructor.reportMissingAsset(asset.url.split("?")[1]);
            }
            if (asset.canFail) return asset;
            error("Fetch", `failed to fetch ${asset.url}`);
        }
    }

    static reportMissingAsset(url) {
        window._MagicRendererInstance.logger.error("missing layout asset", {url});
    }

    /**
     * Renders the surface
     * @public
     * @memberOf SurfaceRenderer
     * @param {Boolean} returnImage - if to return as a base64 image or canvas
     * @return HTMLCanvasElement|String
     * @example
     * renderer.render().then(canvas=>{
     *     console.log(canvas);
     * });
     */
    async render(returnImage = false) {
        if (this.debug) log('starting to render images, sorting areas by seqNo');
        this.sortWells();

        if (this.debug) log('drawing surface', this.surface.surfaceUrl);

        try {
            if (this.debug) log('drawing imageAreas', this.surface.imageAreas);

            // Download assets and images
            await this.downloadAssets();

            try {

                this.canvas = createCanvas(this.width, this.height);
                this.ctx = this.canvas.getContext("2d");

                enableCanvasSmoothing(this.ctx);
                await this.drawBackground();
                disableCanvasSmoothing(this.ctx);

                enableCanvasSmoothing(this.ctx);
                await this.drawImageAreas();
                disableCanvasSmoothing(this.ctx);

                enableCanvasSmoothing(this.ctx);
                if (this.isMlsdk) {
                    await this.drawEmbellishmentsAreas();
                } else {
                    await this.drawSurface();
                }
                disableCanvasSmoothing(this.ctx);

                await this.drawTextAreas();
                return this.output(returnImage);

            } catch (e) {
                error("Images", "Failed to draw images");
            }

        } catch (e) {
            error("SurfaceRenderer", "failed to render surface");
        }
    }

    /**
     * Draws the image areas
     * @private
     * @memberOf SurfaceRenderer
     */
    async drawImageAreas() {
        try {
            if (this.surface.imageAreas.length === 0) return;

            this.ctx.save();
            this.ctx.scale(this.scale, this.scale);
            this.ctx.translate(0, 0);

            for (const imageArea of this.surface.imageAreas) {
                imageArea.x -= this.printableAreaX;
                imageArea.y -= this.printableAreaY;
                this.renderCroppedImage(imageArea);
            }

            this.ctx.restore();
        } catch (e) {
            error("Drawer", `failed to draw imageAreas - ${e.message}`);
        }
    }


    /**
     * Draws the embellishments areas
     * @private
     * @memberOf SurfaceRenderer
     */
    async drawEmbellishmentsAreas() {
        try {
            if (this.surface.imageAreas.length === 0) return;

            this.ctx.save();
            this.ctx.scale(this.scale, this.scale);
            this.ctx.translate(0, 0);

            for (const embellishmentArea of this.surface.embellishmentAreas) {
                this.renderCroppedImage(embellishmentArea);
            }

            this.ctx.restore();
        } catch (e) {
            error("Drawer", `failed to draw embellishmentAreas - ${e.message}`);
        }
    }

    /**
     * Draws the text areas
     * @private
     * @memberOf SurfaceRenderer
     */
    async drawTextAreas() {
        try {
            if (this.surface.textAreas.length === 0) return;

            this.ctx.save();
            this.ctx.scale(this.scale, this.scale);
            this.ctx.translate(0, 0);

            for (const textArea of this.surface.textAreas) {
                if (textArea.imageObject instanceof Image) {
                    drawImage(this.ctx, [textArea.imageObject, textArea.x, textArea.y, textArea.width, textArea.height]);
                }
            }

            this.ctx.restore();
        } catch (e) {
            error("Drawer", `failed to draw textAreas - ${e.message}`);
        }


    }

    static get textsEndpoint() {
        return `https://www.shutterfly.com/creationpath/text/preview`;
    }

    static getTransformation(transformMatrix) {
        return typeof transformMatrix !== "undefined" && transformMatrix ? transformMatrix.match(/matrix\((-?\d+\.?\d*) (-?\d+\.?\d*) (-?\d+\.?\d*) (-?\d+\.?\d*) (-?\d+\.?\d*) (-?\d+\.?\d*)\)/) : [];
    }
}
